/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetPayeeResponse,
  UtxPayeesGetAllParams,
  CreatePayeeResponse,
  CreatePayeeRequest,
  UpdatePayeeRequest
} from './schema'



export const utxPayeesGetAll = (
    params?: UtxPayeesGetAllParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPayeeResponse[]>> => {
    return axios.get(
      `/payees`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxPayeesGetAllQueryKey = (params?: UtxPayeesGetAllParams,) => [`/payees`, ...(params ? [params]: [])];

    
export type UtxPayeesGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof utxPayeesGetAll>>>
export type UtxPayeesGetAllQueryError = AxiosError<unknown>

export const useUtxPayeesGetAll = <TData = Awaited<ReturnType<typeof utxPayeesGetAll>>, TError = AxiosError<unknown>>(
 params?: UtxPayeesGetAllParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxPayeesGetAll>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxPayeesGetAllQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxPayeesGetAll>>> = ({ signal }) => utxPayeesGetAll(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxPayeesGetAll>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create payee of current user
 */
export const utxPayeesCreatePayee = (
    createPayeeRequest: CreatePayeeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreatePayeeResponse>> => {
    return axios.post(
      `/payees`,
      createPayeeRequest,options
    );
  }



    export type UtxPayeesCreatePayeeMutationResult = NonNullable<Awaited<ReturnType<typeof utxPayeesCreatePayee>>>
    export type UtxPayeesCreatePayeeMutationBody = CreatePayeeRequest
    export type UtxPayeesCreatePayeeMutationError = AxiosError<unknown>

    export const useUtxPayeesCreatePayee = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPayeesCreatePayee>>, TError,{data: CreatePayeeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPayeesCreatePayee>>, {data: CreatePayeeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPayeesCreatePayee(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPayeesCreatePayee>>, TError, {data: CreatePayeeRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxPayeesEdit = (
    id: string,
    updatePayeeRequest: UpdatePayeeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPayeeResponse>> => {
    return axios.put(
      `/payees/${id}`,
      updatePayeeRequest,options
    );
  }



    export type UtxPayeesEditMutationResult = NonNullable<Awaited<ReturnType<typeof utxPayeesEdit>>>
    export type UtxPayeesEditMutationBody = UpdatePayeeRequest
    export type UtxPayeesEditMutationError = AxiosError<unknown>

    export const useUtxPayeesEdit = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPayeesEdit>>, TError,{id: string;data: UpdatePayeeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPayeesEdit>>, {id: string;data: UpdatePayeeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxPayeesEdit(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPayeesEdit>>, TError, {id: string;data: UpdatePayeeRequest}, TContext>(mutationFn, mutationOptions)
    }
    